export default {
  'menu.shop-settings.price-visibility': 'Price Visibility',
  'menu.shop-settings': 'Shop Settings',
  'menu.shop-settings.activity-center': 'Activity Center',
  'menu.shop-settings.miniprogram-nav': 'Mini Program Navigation',
  'menu.shop-settings.announcement': 'Announcements',
  'menu.shop-settings.static-assets': 'Operational Images',
  'menu.shop-settings.size-recommendations': 'Size Recommendation Rules',
  'menu.shop-settings.size-recommendation-mapping': 'Size Recommendation Mapping',
  'menu.catalog': 'Product Configuration',
  'menu.catalog.taxonomies': 'Taxonomies',
  'menu.catalog.product-attributes': 'Product Attribute Templates',
  'menu.shop-sorting': 'Product Sorting',
  'menu.users': 'Users',
  'menu.hj': 'Product Management',
  'menu.hj.products': 'Products',
  'menu.hj.purchase-orders': 'Purchase Orders',
  'menu.hj.orders': 'Orders',
  'menu.hj.yarns': 'Yarns',
  'menu.hj.size-attrs': 'Size Fields',
  'menu.hj.size-templates': 'Size Templates',
  'menu.hj.global-settings': 'Global settings',
  'menu.ai': 'AI Image Studio',
  'menu.ai.generation': 'Generation Studio',
  'menu.ai.history': 'Generation History',
  'menu.ai.copy-history': 'Copy History',
  'menu.settings-center': 'Settings Center',
  'menu.settings-center.ai-models': 'AI Model Settings',
  'menu.settings-center.marketing-copy': 'Marketing Copy Template',
  'menu.settings-center.order-process': 'Order Process',
  'menu.settings-center.product-config': 'Product Settings',
  'menu.settings-center.product-config.taxonomies': 'Product Taxonomies',
  'menu.settings-center.product-config.product-attributes': 'Product Attributes',
};
